export default axios => {
    return {
        async get({day, id}) { 
            return await axios.get(`/simulator/simulation/${id}/timesheets?date=${day}`);
        }
    };
};